export enum AttributeIdentifiers {
	AdministrationDate = "administrationDate",
	PrescriptionDate = "prescriptionDate",
	PatientId = "patientId",
	DiagnosisDate = "diagnosisDate",
	LegalEntity = "legalEntity",
	Initials = "initials",
	YearOfBirth = "yearOfBirth",
	RequestReceiptDate = "requestReceiptDate",
	IntendedStartDate = "intendedStartDate",
	BrandName = "brandName",
	GenericName = "genericName",
	Disease = "disease",
	Indication = "indication",
	DecisionTherapy = "decisionTherapy",
	TherapyTrialStartDate = "therapyTrialStartDate",
	TherapyTrialEndDate = "therapyTrialEndDate",
	Rating = "rating",
	CoverageStartDate = "coverageStartDate",
	CoverageEndDate = "coverageEndDate",
	TherapyStartDate = "therapyStartDate",
	DiscontinuationDate = "discontinuationDate",
	PatientEnrolledInTreatment = "patientEnrolledInTreatment",
	ReasonForDiscontinuation = "reasonForDiscontinuation",
	Result = "result",
	PathologicalResponse = "pathologicalResponse",
	ResponseReceived = "responseReceived",
	NumberOfPrescriptionsToDate = "numberOfPrescriptionsToDate",
	ResponseAssessmentDate = "responseAssessmentDate",
	BenefitAssessmentDate = "benefitAssessmentDate",
	AdverseEvent = "adverseEvent",
	TreatingPhysicianTitle = "treatingPhysicianTitle",
	TreatingPhysicianFirstName = "treatingPhysicianFirstName",
	TreatingPhysicianLastName = "treatingPhysicianLastName",
	TreatingPhysicianNr = "treatingPhysicianNr",
	TreatingPhysicianStreet = "treatingPhysicianStreet",
	TreatingPhysicianPlace = "treatingPhysicianPlace",
	TreatingPhysicianPostcode = "treatingPhysicianPostcode",
	TreatmentPack = "treatmentPack",
	PackSize = "packSize",
	PrimaryInterventionDate = "primaryInterventionDate",
	MainItemModel = "mainItemModel",
	MainItemRef = "mainItemRef",
	MainItemLot = "mainItemLot",
	SupportingItemModel = "supportingItemModel",
	SupportingItemRef = "supportingItemRef",
	SupportingItemLot = "supportingItemLot",
	RecurrenceDate = "recurrenceDate",
	TreatingPhysicianEmail = "treatingPhysicianEmail",
	TreatingPhysicianPhoneNo = "treatingPhysicianPhoneNo",
	TreatingPhysicianHospitalName = "treatingPhysicianHospitalName",
	TreatingPhysicianDepartment = "treatingPhysicianDepartment",
	AdverseEventGrade = "adverseEventGrade",
	AdverseEventTrae = "adverseEventTrae",
	AdverseEventAssessmentDate = "adverseEventAssessmentDate",
	AdverseEventDoseModification = "adverseEventDoseModification",
	Quantity = "quantity",
	LowVoltageZone = "lowVoltageZone",
	AdherenceToProtocol = "adherenceToProtocol",
	CtiLineAblated = "ctiLineAblated",
	ResponsiblePhysician = "responsiblePhysician",
	LaVolume = "lavolume",
	LaPressure = "lapressure",
	SecondaryInterventionDate = "secondaryInterventionDate",
	InvoiceId = "invoiceId",
	InvoiceAmount = "invoiceAmount",
	InvoiceDate = "invoiceDate",
	ProviderId = "providerId",
	ProviderName = "providerName",
	ProductId = "productId",
	ProductName = "productName",
	ProductIdType = "productIdType",
	RefundSummaryStatus = "refundSummaryStatus",
	PreviousTherapy = "previousTherapy",
	LdlLevel = "ldlLevel",
	LdlTestDate = "ldlTestDate",
	PatientAge = "patientAge",
	LdlLevelUoM = "ldlLevelUom",
	AssessmentDate = "assessmentDate",
	CholesterolScore = "cholesterolScore",
	ScopeId = "scopeId",
	TopicName = "topicName",
	PlannedAdministration = "plannedAdministration",
	IsLegacyRequestReceiptDate = "legacyRequestReceiptDate",
	InsuranceClaimId = "insuranceClaimId",
	SuggestedDiscountRate = "suggestedDiscountRate",
	DiscountRate = "discountRate",
	Timeframe = "timeframe",
	BasePrice = "basePrice",
	ClinicalTrial = "clinicalTrial",
	MedicalHistory = "medicalHistory",
	FormChat = "formChat",
	PricePreview = "pricePreview",
	RecentCases = "recentCases",
	BrandNameReference = "brandNameReference",
	PackReference = "packReference",
	ProceedWithoutReview = "proceedWithoutReview",
	IsRevoked = "isRevoked",
	RevocationReason = "revocationReason",
	RelatedCases = "relatedCases",
	ExternalFormId = "externalFormId",
	FixedFeeAmount = "fixedFeeAmount",
	PurchaseId = "purchaseId",
	PurchaseDate = "purchaseDate",
	Manufacturer = "manufacturer",
	ManufacturerId = "manufacturerId",
	ItemNo = "itemNo",
	UnitOfPurchase = "unitOfPurchase",
	Notes = "notes",
	RelevantIndication = "relevantIndication",
	TestType = "testType",
	TestDate = "testDate",
	TestResult = "testResult",
	TestUoM = "testUoM",
	TestPurpose = "testPurpose",
	TransfusionType = "transfusionType",
	TransfusionDate = "transfusionDate",
	RowNumber = "rowNumber",
	OrderNr = "orderNr",
	AddedBy = "addedBy",
}
